import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";

import { ClusterUrlQueryParams } from "./urls";
import ClusterCreate from "./views/ClusterCreate";
import ClusterDetails from "./views/ClusterDetails";
import ClusterListComponent from "./views/ClusterList";

const ClusterListPage: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));
  return <ClusterListComponent params={params} />;
};

const ClusterDetailsView: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const { ...qs } = parseQs(location.search.substr(1));
  const params: ClusterUrlQueryParams = {
    ...qs
  };

  return <ClusterDetails id={decodeURIComponent(id)} params={params} />;
};

const Announcements = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.cluster)} />
      <Routes>
        <Route path={""} element={<ClusterListPage />} />
        <Route path={"add"} element={<ClusterCreate />} />
        <Route path={":id"} element={<ClusterDetailsView />} />
      </Routes>
    </>
  );
};

export default Announcements;
